<template>
    <q-layout view="hHh Lpr lff">
        <q-header bordered class="bg-white text-black">
            <q-toolbar class="q-py-sm q-px-md">
                <q-btn no-caps no-wrap flat label="Фотофиксация" to="/" size="lg" />
                <div v-if="$q.screen.gt.sm"
                    class="q-ml-xs q-gutter-md text-body2 text-weight-bold row items-center no-wrap">
                    <q-btn-dropdown stretch flat no-caps class="q-ml-xs" label="Проекты" split to="/projects">
                        <q-list>
                            <q-item-label header>Недавние проекты</q-item-label>

                            <q-item clickable v-close-popup replace :to="`/projects/${project.id}/tasks`"
                                v-for="project in lastProjects">
                                <q-item-section avatar>
                                    <avatar :project="project" />
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label>{{ project.name }}</q-item-label>
                                    <q-item-label caption>{{ project.code }}</q-item-label>
                                </q-item-section>
                            </q-item>
                        </q-list>
                    </q-btn-dropdown>

                    <q-btn stretch flat no-caps class="q-ml-xs" label="Организации" to="/organizations" />
                </div>
                <q-space />

                <div class="q-pl-sm q-gutter-sm row no-wrap">
                    <q-select v-if="store.loggedIn" clearable square filled use-input hide-selected :options="options"
                        v-model="text" @filter="filter" :stack-label="false" dense>
                        <template v-slot:prepend>
                            <q-icon name="search" />
                        </template>
                        <template v-slot:option="scope">
                            <q-expansion-item v-bind="scope.itemProps" default-opened>
                                <template v-slot:header>
                                    <q-item-section avatar>
                                        <avatar :project="scope.opt.project" size="24px" />
                                    </q-item-section>

                                    <q-item-section>
                                        <q-item-label>{{ scope.opt.project.name }}</q-item-label>
                                        <q-item-label caption>{{ scope.opt.project.code }}</q-item-label>
                                    </q-item-section>
                                </template>
                                <q-item clickable :to="`/projects/${scope.opt.project.id}/tasks/${task.id}`"
                                    :inset-level="1" v-for="task in scope.opt.tasks">
                                    <q-item-section>
                                        <q-item-label>{{ task.name }}</q-item-label>
                                        <q-item-label caption>{{ task.code }}</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </q-expansion-item>
                        </template>
                        <template v-slot:no-option>
                            <q-item>
                                <q-item-section class="text-italic text-grey">
                                    Ничего не найдено
                                </q-item-section>
                            </q-item>
                        </template>
                    </q-select>
                    <q-btn v-if="!store.loggedIn" no-caps flat no-wrap label="Войти" to="/login" />
                    <q-btn-dropdown flat no-caps v-else :label="user?.username">
                        <div class="row no-wrap q-pa-md">
                            <div class="column items-center">
                                <div class="text-subtitle2 q-mb-xs">{{ user?.email }}</div>

                                <q-btn color="primary" label="Настройки" flat to="/user/settings" padding="xs"
                                    v-close-popup />

                                <q-btn color="negative" label="Выйти" flat padding="xs" @click="store.logout" />
                            </div>
                        </div>
                    </q-btn-dropdown>
                </div>

            </q-toolbar>
        </q-header>

        <q-drawer v-if="!!$route.meta.menu" side="left" bordered :mini="$q.screen.xs" show-if-above>
            <component :is="menus[$route.meta.menu]" />
            <!-- drawer content -->
        </q-drawer>

        <q-drawer width="400" v-model="openPhotos" v-if="openPhotos && !!$route.meta.photos" side="right" bordered overlay>
            <photo-list />
            <!-- drawer content -->
        </q-drawer>

        <q-page-container>

            <router-view />
        </q-page-container>

        <!--    <q-footer bordered class="bg-white">
              <div class="text-center">
                <img class="col-12" height="50" src="/logo.png">
              </div>
            </q-footer>-->
        <photo id="test" />
    </q-layout>
</template>
<script setup lang="ts">
import { ref } from "vue";
import ProjectMenu from "./components/menu/ProjectMenu.vue";
import OrganizationMenu from "./components/menu/OrganizationMenu.vue";
import { useUserStore } from "./store/user";
import { storeToRefs } from "pinia";
import { useTaskSearch } from "./composables/task";
import { ProjectTask } from "./models/task";
import Avatar from "./components/Avatar.vue";
import PhotoList from "./components/menu/PhotoList.vue";
import { useProjectStore } from "./store/project";
import Photo from "./components/Photo.vue";
import { usePhotoStore } from "./store/photo";


const text = ref("")
const search = ref("")
const { data, execute } = useTaskSearch(search)
const options = ref<ProjectTask[]>([])

const photoStore = usePhotoStore()
const { open: openPhotos, visibleViewer, viewedImage, photosUrl, loading, last } = storeToRefs(photoStore)
function filter(val: string, update: (callbackFn: () => void) => void,) {
    search.value = val
    execute().then(() => {
        update(() => {
            options.value = data.value?.content ?? []
        })
    })

}

const menus = {
    ProjectMenu,
    OrganizationMenu
}
const store = useUserStore()
const { user } = storeToRefs(store)

const projectStore = useProjectStore()
const { lastProjects } = storeToRefs(projectStore)
</script>
<style>
#test {
    z-index: 3000;
}

.vel-modal {
    z-index: 3000;
}
</style>